import { Component } from '@theme/component';

class FaqTabs extends Component {
  requiredRefs = ['tablist'];

  connectedCallback() {
    super.connectedCallback();
    this.#centerActive();
  }

  get pills() {
    const { pills } = this.refs;
    return Array.isArray(pills) ? pills : pills ? [pills] : [];
  }

  get panels() {
    const { panels } = this.refs;
    return Array.isArray(panels) ? panels : panels ? [panels] : [];
  }

  selectTab = (event) => {
    const pill = event.target instanceof HTMLElement ? event.target.closest('[role="tab"]') : null;
    if (!(pill instanceof HTMLElement)) return;
    const index = Number(pill.dataset.index);
    if (Number.isNaN(index)) return;
    this.#activate(index);
    this.#centerActive();
  };

  handleKey = (event) => {
    const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();

    const pills = this.pills;
    const current = pills.findIndex((p) => p.getAttribute('aria-selected') === 'true');
    const last = pills.length - 1;
    let next = current;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        next = current <= 0 ? last : current - 1;
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        next = current >= last ? 0 : current + 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
    }

    this.#activate(next);
    pills[next]?.focus();
    this.#centerActive();
  };

  #activate(index) {
    this.pills.forEach((pill, i) => {
      const active = i === index;
      pill.setAttribute('aria-selected', active ? 'true' : 'false');
      pill.tabIndex = active ? 0 : -1;
      pill.classList.toggle('is-active', active);
    });

    this.panels.forEach((panel, i) => {
      const active = i === index;
      panel.hidden = !active;
      if (active) {
        // Re-open the first FAQ of the newly activated tab; close the rest.
        panel.querySelectorAll('details').forEach((d, j) => {
          d.open = j === 0;
        });
      }
    });
  }

  #centerActive() {
    const list = this.refs.tablist;
    if (!(list instanceof HTMLElement)) return;
    // Only runs on mobile where the tablist actually overflows.
    if (list.scrollWidth <= list.clientWidth + 1) return;

    const active = list.querySelector('[aria-selected="true"]');
    if (!(active instanceof HTMLElement)) return;

    const listRect = list.getBoundingClientRect();
    const pillRect = active.getBoundingClientRect();
    const edgeThreshold = listRect.width * 0.25;
    const distanceFromLeft = pillRect.left - listRect.left;
    const distanceFromRight = listRect.right - pillRect.right;

    if (distanceFromLeft < edgeThreshold || distanceFromRight < edgeThreshold) {
      const target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
      list.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
  }
}

if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', FaqTabs);
}
